import React, { Component } from 'react'

/* Poker UI */
import { Chip3D } from '@cuba-go/poker-ui'

class UltimateRates extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    image = (type, pass = false) => {

        const { ante, blind, trips, result, chips } = this.props

        const chipsHidden = type === 'ante' ? (result && result.result === "lose" && !result.ante) : type === 'blind' ? (result && result.result === "lose") : (result && !result.playerTripsMultiplier)

        const value = type === 'ante' ? ante : type === 'blind' ? blind : trips
        // const value = 500
        const text = type === 'ante' ? 'ANTE' : type === 'blind' ? 'BLIND' : 'TRIPS'

        if (value && !pass && !chipsHidden) {
            return (
                <div className="ultimate-chip-rate">
                    <Chip3D value={value} size={75} chips={chips} />
                </div>
            )
        }

        return <p>{text}</p>

    }

    /* ANTE, BLIND, TRIPS RESULT */

    imageResult = (type) => {
        const { result, ante, blind, trips, chips } = this.props
        const tempValue = type === 'ante' ? ante : type === 'blind' ? blind : trips
        const key = type === 'ante' ? "anteMultiplier" : type === 'blind' ? 'blindMultiplier' : 'playerTripsMultiplier'

        // const result = { anteMultiplier: 1, blindMultiplier: 30, playerTripsMultiplier: 500 }

        if (result && tempValue && result[key] && result[key] > 0) {

            const value = tempValue * result[key]

            return (
                <div className="u-chip-image-result-multiplier-box">
                    <div className="u-chip-image-result-multiplier-text">{result[key]}x</div>
                    <div className="u-chip-image-result-rate">
                        <Chip3D value={value} size={75} chips={chips} />
                    </div>
                </div>
            )
        }
    }


    /* DRAW BET */
    _bet = () => {

        const { betX, ante, result, chips } = this.props

        // const betX = 4

        if (betX) {

            const bet = ante * betX

            const chipsHidden = result && result.result === "lose"

            if (ante && !chipsHidden) {
                return (
                    <div className={`ultimate-chip-rate ultimate-chip-bet`}>
                        <Chip3D value={bet} size={84} chips={chips} />
                    </div>
                )
            }
        }

        return <p>BET</p>

    }

    /* BET Result */
    _betResult = () => {
        const { result, ante, betX, chips } = this.props
        const key = 'betMultiplier'
        // const result = { betMultiplier: 4 }

        if (result && result[key] && result[key] > 0) {

            const value = (ante * betX) * result[key]

            return (
                <div className="u-chip-bet-result-multiplier-box">
                    <div className="u-chip-bet-result-multiplier-text">{result[key]}x</div>
                    <div className="u-chip-bet-result-rate">
                        <Chip3D value={value} size={84} chips={chips} />
                    </div>
                </div>
            )
        }
    }


    render = () => {

        const { ante, isChoice, trips, result, backColor, add, gameplay, action, disabled } = this.props

        const colorStyle = { backgroundColor: backColor }

        const anteAnimation = isChoice && !ante ? "animated" : ""
        const tripsAnimation = isChoice && ante && !trips ? "animated" : ""

        const anteAvailable = isChoice ? "cursor" : ""
        const tripsAvailable = isChoice && ante ? "cursor" : ""

        const disabledTrips = !ante ? "disabledTrips" : ""

        const style = gameplay ? "game" : ""

        const chipsStyle = disabled ? "disabled" : ""

        const pass = action === 'pass'
        return (
            <div className={`ultimate-chips-bottom ${style}`}>
                <div className={`trips-box ${disabledTrips}`}>
                    <div className='trips-rhombus-outer'>
                        <div className='trips-rhombus-inner'>
                            <div className={`r-trips ${tripsAnimation}`} style={colorStyle} />
                        </div>
                    </div>
                    <div className={`trips ${tripsAvailable}`} onClick={() => add('trips')}>
                        {this.image('trips')}
                        {this.imageResult('trips')}
                    </div>
                </div>
                <div className={`ultimate ${chipsStyle}`}>
                    <div className="ante-blind">
                        <div className='rhombus-outer'>
                            <div className='rhombus-inner'>
                                <div className={`rhombus ante ${anteAnimation}`} style={colorStyle} />
                                <div className={`rhombus blind ${anteAnimation}`} style={colorStyle} />
                            </div>
                        </div>

                        <div className='front'>
                            <div className={`ante ${anteAvailable}`} onClick={() => add('ante')}>
                                {this.image('ante', pass)}
                                {this.imageResult('ante')}
                            </div>
                            <div className={`blind ${anteAvailable}`} onClick={() => add('ante')}>
                                {this.image('blind', pass)}
                                {this.imageResult('blind')}
                            </div>
                        </div>
                    </div>
                    <div className='holdem-bet'>
                        <div className='holdem-bet-outer'>
                            <div className='holdem-bet-inner' style={colorStyle} />
                        </div>
                        <div className='bet-inner'>
                            {this._bet()}
                            {this._betResult()}
                        </div>

                    </div>
                </div>
            </div>
        )
    }

}

export default UltimateRates